export enum AccountSettingsInputName {
  Password = 'Password',
  OldPassword = 'Old Password',
  NewPassword = 'New Password',
  ConfirmNewPassword = 'Confirm New Password',
  NewEmail = 'New Email',
  NewPhone = 'New Phone',
}
